import { render } from "./AgregarLogotipo.vue?vue&type=template&id=88c7370c&scoped=true"
import script from "./AgregarLogotipo.vue?vue&type=script&lang=js"
export * from "./AgregarLogotipo.vue?vue&type=script&lang=js"

import "./AgregarLogotipo.vue?vue&type=style&index=0&id=88c7370c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88c7370c"]])

export default __exports__